import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
@customElement('page-footer')
export class PageFooterElement extends LitElement {
  static get styles() {
    return css`
      :host {
        background: rgba(0, 0, 0, 0.9);
        padding: 1rem;
        box-sizing: border-box;
        display: block;
        text-align: right;
        color: #fff;
      }
      #lang-select {
        height: 2rem;
        font-size: 1rem;
      }
    `;
  }
  _onLangChanged(e: Event) {
    const selectElement = e.target as HTMLSelectElement;
    const lang = selectElement.value;
    const pathMatch = window.location.pathname.match(/^(\/intl\/\w+)?(\/.+)$/);
    if (!pathMatch) return;
    window.location.href =
      lang === 'ja' ? `/intl/ja${pathMatch[2]}` : `/intl/en${pathMatch[2]}`;
  }

  render() {
    return html`
      <label for="lang-select">Language</label>
      <select @change="${this._onLangChanged}" id="lang-select">
        <option value="ja" .selected=${document.documentElement.lang === 'ja'}>
          日本語
        </option>
        <option value="en" .selected=${document.documentElement.lang === 'en'}>
          English
        </option>
      </select>
    `;
  }
}
